<template>
  <div class="card mb-4">
    <div class="card-header">
      <img v-if="option.image" :src="option.image | image(imageDimensions)">
      <div id="image" :class="{'card-image': option.image, 'card-header': !option.image}" :style="{background: option.value + ' !important' }">
        <span v-if="option.name" :class="{'badge badge-success': option.image, 'badge badge-success float-right': !option.image}">{{ option.name }}</span>
      </div>
    </div>
    <div class="card-footer">
      <div class="text-center">
        <div class="custom-control custom-radio custom-control-inline">
          <input :id="'color_' + option.id" type="radio" class="custom-control-input" :checked="option.selected">
          <label class="custom-control-label" :for="'color_' + option.id">{{ option.label }} <span v-if="option.discount > 0" class="badge badge-pill badge-danger">-{{ option.discount }}%</span></label>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    option: {
      type: Object,
      default: null
    }
  },
  computed: {
    imageDimensions () {
      let str = ''
      const width = 150
      const height = 100

      if (width) {
        str = Number.parseInt(width)
      }

      str += 'x'

      if (height) {
        str += Number.parseInt(height)
      }

      return str
    }
  }
}
</script>
